import React, { useEffect, useState, useMemo } from "react";
import {
    Delete as DeleteIcon,
    Edit as EditIcon,
    Add as AddIcon,
    TrendingUp,
} from "@material-ui/icons";
import DataTable from "../../../components/data-table";
import FormModalContent from "./form";
import ConfirmModalContent from "../../../components/confirm-modal-content";
import PaletteIcon from "@material-ui/icons/Palette";
import { useErrorHandler } from "../../../hooks";

import mainPageService from "../../../services/main-page.service";
import ChangeSort from "./changeSort";

const defaultKeys = [
    {
        title: "نام",
        field: "name",
        active: true,
    },
];

export default function SliderTable(props) {

    const errorHandler = useErrorHandler();

    const [data, setData] = useState([]);
    const deleteItem = async (item) => {
        const res = await mainPageService.deleteMainPage(item.id);
        if(res.error){
            const error = res.error.response.data.error;
            errorHandler(error);
        }
    };

    const headerCells = useMemo(
        () => [
            {
                field: "index",
                title: "ردیف",
                mainField: true,
            },
            {
                field: "title",
                title: "عنوان",
                mainField: true,
            },
            {
                field: "type",
                title: "نوع",
                mainField: true,
            },
            {
                field: "image",
                title: "عکس",
                renderer: (val) =>
                    val ? <img className="main-page-img" src={val} alt="" /> : "-",
            },
        ],
        []
    );

    useEffect(() => {
        setNewData();
    }, [props.data.sliders]);

    const setNewData = () => {
        setData(props.data.sliders.map(item => ({...item, index: item.sort+1})).sort((a, b) => a.index - b.index))
    }

    return (
        <div className="p-3">
            <DataTable
                headCells={headerCells}
                data={data}
                order={{order: "ASC", orderBy: "index"}}
                onRefresh={props.onRefresh}
                rowActions={[
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <EditIcon />,
                        modalContent: (props) => <FormModalContent {...props} type="slide" name="اسلایدر" />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <TrendingUp />,
                        hidden: (data) => data.type === "slider",
                        modalContent: (props) => <ChangeSort {...props} type={"slide"} allData={data}/>,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <DeleteIcon />,
                        modalContent: (props) => (
                            <ConfirmModalContent
                                onConfirm={() => deleteItem(props.data)}
                                confirmText={props.data.name}
                                close={props.close}
                            />
                        ),
                    },
                ]}
                actions={[
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <AddIcon />,
                        tooltip: "ایجاد اسلاید",
                        modalContent: (props) => <FormModalContent {...props} type="slide" name="اسلایدر" />,
                    },
                ]}
                searchKeys={defaultKeys}
                title="اسلایدر صفحه خانه"
            />

        </div>
    );
}
